import React from 'react';
import { connect } from 'react-redux';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware/properties';
import store from '../../redux/store';
import _ from 'lodash';
import { colorTheme } from '../../utils/constants';
import {
    showLoading,
    fetchPropertyTenants,
    fetchBankStatementTransactions,
    saveBankStatementTransactions,
    fetchCurrency,
    fetchOptions
} from '../../redux/actions';
import UploadBankStatement from './uploadBankStatement';
import { IonButton, IonIcon } from '@ionic/react';
import { arrowBack, arrowForward, cash, document, hourglass } from 'ionicons/icons';
import PaymentsTable from './paymentsTable';
import { WizardStep } from '../Wizard/WizardStep';
import Wizard from '../Wizard';
import ReviewTransactions from './reviewTransactions';
import * as PermChecker from '../../utils/PermUtils';

const mapStateToProps = state => ({
    properties: state.properties,
    units: state.units,
    tenants: state.tenants,
    currency: state.currency,
    options: state.options,
})

const mapDispatchToProps = {
    showLoading,
    fetchPropertyTenants,
    fetchBankStatementTransactions,
    saveBankStatementTransactions,
    fetchCurrency,
    fetchOptions
}

const SEQUENCE = ["Select Bank Statement", "Transactions", "Created Payments"]


class BankStatement extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            currentStep: _.first(SEQUENCE),
            bankStatementFile: null,
            bankStatementFileName: "",
            readOnly: false,
            transactions: [],
            filteredTransactions: [],
            payments: [],
            userAllPerms: {},
        }
        this.stepRefs = {};
        for (let sequence of SEQUENCE){
            this.stepRefs[sequence] = React.createRef();
        }
    }

    async componentDidMount(){
        if (_.isEmpty(this.props.currency)) {
            await this.props.fetchCurrency();
        }
        if (_.isEmpty(this.props.properties)) {
            await store.dispatch(fetchPropertiesUnitsTenants);
            this.setState({
                propertyIds: Object.keys(this.props.properties)
            });
        }
        if(_.isEmpty(this.props.options)){
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }
        const hasAllMsgPerm = PermChecker.checkUserHasPermission(PermChecker.MESSAGE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllPaymentPerm = PermChecker.checkUserHasPermission(PermChecker.PAYMENT_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        this.setState({
            userAllPerms: {message: hasAllMsgPerm, payment:hasAllPaymentPerm}
        });
    }

    savePayments(payments){
        this.setState({payments});
        this._nextStep();
    }


    _prevStep = () => {
        const index = SEQUENCE.indexOf(this.state.currentStep);
        const stepId = SEQUENCE[index - 1];
        this.stepRefs[stepId].current.scrollIntoView();
        this.setState({
            currentStep: stepId
        });
    }

    _nextStep = () => {
        const index = SEQUENCE.indexOf(this.state.currentStep);
        const stepId = SEQUENCE[index + 1];
        this.stepRefs[stepId].current.scrollIntoView();
        this.setState({
            currentStep: stepId
        });
    }

    _changeStep = (stepId) => {
        this.stepRefs[stepId].current.scrollIntoView();
        this.setState({
            currentStep: stepId
        });
    }

    async handleChangeFile(event){
        if(event.target.files && event.target.files.length > 0){
            this.setState({
                bankStatementFile: event.target.files[0],
                bankStatementFileName: event.target.files[0].name
            });
            this.props.showLoading(true);
            const action = await this.props.fetchBankStatementTransactions(event.target.files[0]);
            if(!action.errors){
                this.setState({
                    transactions: action.payload.transactions.map(transaction => ({
                        ...transaction,
                        date: transaction.date == "NaT"? "" : transaction.date,
                    })),
                    payments: []
                })
                this._nextStep();
            }
            this.props.showLoading(false);
        }

    }

    renderSelectFile(){
        return <UploadBankStatement
            file={this.state.bankStatementFile}
            fileName={this.state.bankStatementFileName}
            readOnly={this.state.readOnly}
            handleChangeFile={this.handleChangeFile.bind(this)}
        />
    }

    renderTransactions(){
        return (<ReviewTransactions
            transactions={this.state.transactions}
            savePayments={this.savePayments.bind(this)}
            editingDisabled={this.state.payments.length > 0}
            currency={this.props.currency}
        />);
    }

    renderPayments(){
        return (<PaymentsTable payments={this.state.payments} userAllPerms={this.state.userAllPerms} />);
    }

    render(){
        const { currentStep } = this.state;
        return (
            <div className='px-1'>
                <div className="">
                    <Wizard
                        activeStep={currentStep}
                        onStepChanged={(stepIndex) => this._changeStep(stepIndex)}
                    >
                        <WizardStep
                            id={SEQUENCE[0]}
                            refProp={this.stepRefs[SEQUENCE[0]]}
                            icon={ <IonIcon icon={document} /> }
                            complete={this.state.bankStatementFile != null}
                        >
                            Select Bank Statement
                        </WizardStep>

                        <WizardStep
                            id={SEQUENCE[1]}
                            refProp={this.stepRefs[SEQUENCE[1]]}
                            icon={ <IonIcon icon={hourglass} /> }
                            complete={this.state.payments.length > 0}
                            disabled={this.state.bankStatementFile == null}
                        >
                            Review Transactions
                        </WizardStep>

                        <WizardStep
                            id={SEQUENCE[2]}
                            refProp={this.stepRefs[SEQUENCE[2]]}
                            icon={ <IonIcon icon={cash} /> }
                            complete={this.state.payments.length > 0}
                            disabled={this.state.bankStatementFile == null && this.state.payments.length == 0}
                        >
                            Created Payments
                        </WizardStep>
                    </Wizard>
                </div>

                <div className="">
                {
                    (() => {
                        switch(currentStep) {
                            case SEQUENCE[0]:
                                return this.renderSelectFile();
                            case SEQUENCE[1]:
                                return this.renderTransactions();
                            case SEQUENCE[2]:
                                return this.renderPayments();

                        }
                    })()
                }
                </div>

                <div className="p-4 bt-0">
                    <div className="d-flex justify-content-between">
                        {
                            currentStep !== SEQUENCE[0] && (
                                <IonButton
                                    onClick={() => {this._prevStep()}}
                                    fill='outline'
                                    id='prev-button'
                                    className='mr-3'
                                >
                                    <IonIcon className="mr-2" icon={arrowBack}></IonIcon>
                                    Previous
                                </IonButton>
                            )
                        }
                        {
                            currentStep == SEQUENCE[SEQUENCE.length - 1]?
                            (
                                <IonButton
                                    onClick={() => this.props.handleCloseModal() }
                                    id='done-button'
                                    className=""
                                >
                                    Done
                                </IonButton>
                            ) :
                            (
                                <IonButton
                                    onClick={() => {this._nextStep()}}
                                    className="ml-auto px-0"
                                    id='next-button'
                                    size="md"
                                    fill='outline'
                                    disabled={this.state.bankStatementFile == null}
                                >
                                    Next
                                    <IonIcon className="ml-2" icon={arrowForward}></IonIcon>
                                </IonButton>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BankStatement);
